import { ConvertPriceToString, CapitalizeFirstLowercaseRest } from "../../../Helpers/CustomConverter";
import useGetProductIndexWithMask from "../../BasketPage/Hooks/useGetProductIndexWithMask";

const InvoicesItem = ({ item }) => {
  const { getProductIndexWithMask } = useGetProductIndexWithMask()
  return (
    <tr className="hoverable-row">
      <td style={{ alignContent: "center", verticalAlign: 'middle' }}>{getProductIndexWithMask(item.index)}</td>
      <td style={{ alignContent: "center", verticalAlign: 'middle' }}>{CapitalizeFirstLowercaseRest(item.title)} <br/>{CapitalizeFirstLowercaseRest(item.description)} </td>
      <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: "right" }}>
        {item.qtyStock.toLocaleString(undefined, { minimumFractionDigits: 2 }) +
          " " +
          item.baseUnit}
      </td>
      <td style={{ alignContent: "center", textAlign: "right" }}>
        <span style={{ fontWeight: "bold" }}>{ConvertPriceToString(item.priceGross)}</span><br />{ConvertPriceToString(item.priceNet)}
      </td>
      <td style={{ alignContent: "center", textAlign: "right" }}>
        <span style={{ fontWeight: "bold" }}>{ConvertPriceToString(item.priceGross * item.qtyStock)}</span><br />{ConvertPriceToString(item.priceNet * item.qtyStock)}
      </td>
    </tr>
  );
};

export default InvoicesItem;
